export const LIST_SALE_REPORTS = 'LIST_SALE_REPORTS';
export const FETCH_SALE_REPORTS = 'FETCH_SALE_REPORTS';
export const CLEAR_SALE_REPORTS = 'CLEAR_SALE_REPORTS';


export const CLEAR_DAILY_REPORTS = 'CLEAR_DAILY_REPORTS';

export const LIST_DAILY_REPORTS = 'LIST_DAILY_REPORTS';
export const FETCH_DAILY_REPORTS = 'FETCH_DAILY_REPORTS';
export const CLEAR_LOADING = 'CLEAR_LOADING';

export const LIST_MIX_DAILY_REPORTS = 'LIST_MIX_DAILY_REPORTS';
export const FETCH_MIX_DAILY_REPORTS = 'FETCH_MIX_DAILY_REPORTS';
export const CLEAR_MIX_DAILY_REPORTS = 'CLEAR_MIX_DAILY_REPORTS';
export const CLEAR_MIX_DAILY_LOADING = 'CLEAR_MIX_DAILY_LOADING';

export const LIST_MIX_TOTAL_REPORTS = 'LIST_MIX_TOTAL_REPORTS';
export const FETCH_MIX_TOTAL_REPORTS = 'FETCH_MIX_TOTAL_REPORTS';
export const CLEAR_MIX_TOTAL_REPORTS = 'CLEAR_MIX_TOTAL_REPORTS';
export const CLEAR_MIX_TOTAL_LOADING = 'CLEAR_MIX_TOTAL_LOADING';

export const FETCH_FILTER_REBATE = 'FETCH_FILTER_REBATE';
export const LIST_FILTER_REBATE = 'LIST_FILTER_REBATE';


export const LIST_SETTLEMENT = 'LIST_SETTLEMENT';
export const FETCH_SETTLEMENT = 'FETCH_SETTLEMENT';
export const CLEAR_SETTLEMENT = 'CLEAR_SETTLEMENT';
export const MODIFIED_SETTLEMENT = 'MODIFIED_SETTLEMENT';
export const LOADING_SETTLEMENT = 'LOADING_SETTLEMENT';

export const LIST_MIX_SETTLEMENT = 'LIST_MIX_SETTLEMENT';
export const FETCH_MIX_SETTLEMENT = 'FETCH_MIX_SETTLEMENT';
export const CLEAR_MIX_SETTLEMENT = 'CLEAR_MIX_SETTLEMENT';

export const LIST_OLD_BALANCE = 'LIST_OLD_BALANCE';
export const FETCH_OLD_BALANCE = 'FETCH_OLD_BALANCE';
export const CLEAR_OLD_BALANCE = 'CLEAR_OLD_BALANCE';
export const MODIFIED_OLD_BALANCE = 'MODIFIED_OLD_BALANCE';
export const LOADING_OLD_BALANCE = 'LOADING_OLD_BALANCE';

export const LIST_LOAN = 'LIST_LOAN';
export const FETCH_LOAN = 'FETCH_LOAN';
export const CLEAR_LOAN = 'CLEAR_LOAN';
export const MODIFIED_LOAN = 'MODIFIED_LOAN';
export const LOADING_LOAN = 'LOADING_LOAN';

export const FETCH_TOTAL_REPORT = 'FETCH_TOTAL_REPORT';
export const LIST_TOTAL_REPORT = 'LIST_TOTAL_REPORT';
export const CLEAR_TOTAL_REPORT = 'CLEAR_TOTAL_REPORT';
export const LOADING_TOTAL_REPORT = 'LOADING_TOTAL_REPORT';

export const FETCH_MAIN_REPORT = 'FETCH_MAIN_REPORT';
export const LIST_MAIN_REPORT = 'LIST_MAIN_REPORT';
export const CLEAR_MAIN_REPORT = 'CLEAR_MAIN_REPORT';
export const LOADING_MAIN_REPORT = 'LOADING_MAIN_REPORT';

export const LIST_BALANCE = 'LIST_BALANCE';
export const FETCH_BALANCE = 'FETCH_BALANCE';
export const FETCH_TICKET = 'FETCH_TICKET';
export const DELETE_TICKET = 'DELETE_TICKET';
export const LIST_TICKET = 'LIST_TICKET';
export const CLEAR_TICKET = 'CLEAR_TICKET';

export const LIST_MEMBER_REPORT = 'LIST_MEMBER_REPORT';
export const FETCH_MEMBER_REPORT = 'FETCH_MEMBER_REPORT';
export const CLEAR_MEMBER_REPORT = 'CLEAR_MEMBER_REPORT';


// Report V1
export const LIST_DAILY_REPORTS_V1 = 'LIST_DAILY_REPORTS_V1';
export const FETCH_DAILY_REPORTS_V1 = 'FETCH_DAILY_REPORTS_V1';
export const CLEAR_DAILY_REPORTS_V1 = 'CLEAR_DAILY_REPORTS_V1';

export const FETCH_PERSONAL_REPORT = 'FETCH_PERSONAL_REPORT';
export const LIST_PERSONAL_REPORT = 'LIST_PERSONAL_REPORT';
export const CLEAR_PERSONAL_REPORT = 'CLEAR_PERSONAL_REPORT';
export const LOADING_PERSONAL_REPORT = 'LOADING_PERSONAL_REPORT';

export const FETCH_PERSONAL_DAILY_REPORT = 'FETCH_PERSONAL_DAILY_REPORT';
export const LIST_PERSONAL_DAILY_REPORT = 'LIST_PERSONAL_DAILY_REPORT';
export const CLEAR_PERSONAL_DAILY_REPORT = 'CLEAR_PERSONAL_DAILY_REPORT';
export const LOADING_PERSONAL_DAILY_REPORT = 'LOADING_PERSONAL_DAILY_REPORT';

export const LIST_PROTEST = 'LIST_PROTEST';
export const FETCH_PROTEST = 'FETCH_PROTEST';
export const CLEAR_PROTEST = 'CLEAR_PROTEST';
export const MODIFIED_PROTEST = 'MODIFIED_PROTEST';

export const LIST_PAPER_REPORT = 'LIST_PAPER_REPORT';
export const FETCH_PAPER_REPORT = 'FETCH_PAPER_REPORT';
export const CLEAR_PAPER_REPORT = 'CLEAR_PAPER_REPORT';